// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__uLWE5","footer":"Form_footer__AHduv"};